(function () {
    'use strict';

    a3_pilot_reports.directive('certificateExam', certificateExam);
    /**
    * @ngdoc directive
    * @name certificateExam
    * @restrict E
    * @description
    *   Implementation of certificate exam grading
    * @example
    *   Usage:
    *   <certificate-exam></certificate-exam>
    * @ngInject
    */
    function certificateExam(TrainingSessionFactory, FlightSessionFactory) {
        function link(scope, element, attrs) {
            if (scope.trainees) collapseAll();

            scope.validateTrainee = validateTrainee;
            scope.getRemainingCharacters = getRemainingCharacters;
            scope.collapseAll = collapseAll;
            scope.gradeUp = gradeUp;
            scope.gradeDown = gradeDown;

            var courseId = scope.dutyCourse.Id;

            var isGround = false;
            if(scope.groundDuty){
                isGround = true;
                var date = scope.groundDuty.DutyDateS;
                var dutyId = scope.groundDuty.Id;
            }
            else{
                var date = scope.crewRouteDuty.date;
                var dutyNo = scope.crewRouteDuty.DutyNo;
                var dutyDay = scope.crewRouteDuty.DutyDay;
            }   

            var gradeBase = scope.selectedPhase.ReleaseGrading.CertificateGradeBase;

            scope.gradeBase = gradeBase;
            scope.gradeMin = 0;
            scope.gradeMax = 100;

            //Accordion setting
            scope.oneAtATime = true;
            scope.gradingStatus = 'All';


            //Initialize trainees 
            scope.sessions = [];
            scope.trainees.filter(x => x.EligibilityStatus && !x.Session.Absent).forEach(function (trainee) {
                var session = trainee.Session.ReleaseGrading;
                session.Name = trainee.Name;
                session.AimsId = trainee.AimsId;
                session.isOpen = false;

                if(!session.CertificateOutcome)  session.CertificateOutcome = "Pass";
                if(gradeBase && !session.Grade) session.Grade = gradeBase;
                if(!gradeBase)  session.Grade = null;

                scope.sessions.push(session);
            });

            scope.sessions.forEach(function(traineeSession){
                validateGrading(traineeSession);
            });

            function validateGrading(trainee){
                // Invalid grading
                // 1. If none
                // 2. Over gradeMax
                // 3. Below gradeMin
                // 4. Non numeric
                trainee.isCertificateValid = gradeBase ? trainee.Grade != null && trainee.Grade != undefined : true;
            }

            function validateTrainee(trainee){
                if(gradeBase){
                    validateGrading(trainee);
                    if(trainee.isCertificateValid){
                        calculateOutcome(trainee);
                    }
                }
            
                if(isGround){
                    TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) { console.log(e) })
                }
                else{
                    FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) { console.log(e) })
                }
            }

            function gradeUp(trainee){
                if(trainee.isCertificateValid && trainee.Grade < scope.gradeMax){
                    trainee.Grade++;
                }
                if(!trainee.isCertificateValid){
                    trainee.Grade++;
                }
                validateTrainee(trainee);
            }

            function gradeDown(trainee){
                if(trainee.isExamValid && trainee.Grade > scope.gradeMin){
                    trainee.Grade--;
                }
                if(!trainee.isExamValid){
                    trainee.Grade--;
                }
                validateTrainee(trainee);
            }

            function calculateOutcome(trainee){
                if(trainee.Grade < gradeBase){
                    trainee.CertificateOutcome = "Fail";
                }
                else{
                    trainee.CertificateOutcome = "Pass";
                }
            }
        

            function getRemainingCharacters(text, max) {
                if (typeof (text) === "undefined" || text === null) return '';
                if (typeof (max) === "undefined" || max === null || max < 0 || !max) max = 4000;
                var length = text.length;

                return 'characters left: ' + (max - length);
            }

            function collapseAll() {
                scope.isAllOpen = !scope.isAllOpen;
                scope.trainees.forEach(function (trainee) {
                    var session = trainee.Session.ReleaseGrading;
                    session.isOpen = scope.isAllOpen;
                });
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/certificate-exam.tpl.html',
            scope: false,
            link: link
        }
    }

})();
